// Shared Delco Chefs brand mark — single source of truth for the logo image.
// Use <BrandMark size={N}/> anywhere a small icon is needed.
// Use <BrandLogo/> for header (icon + wordmark).
export const LOGO_URL = "https://customer-assets.emergentagent.com/job_meal-map-live/artifacts/9qrf2lqc_Delco%20chef%20poster.png";

export function BrandMark({ size = 40, className = "" }) {
  // Standalone logo — no shape/ring/background. Height sets the size, width auto-scales.
  return (
    <img
      src={LOGO_URL}
      alt="Delco Chefs"
      className={`inline-block object-contain select-none ${className}`}
      style={{ height: size, width: "auto", maxWidth: size * 2.5 }}
      draggable={false}
    />
  );
}

export function BrandLogo({ markSize = 36, textClass = "text-lg font-bold" }) {
  return (
    <div className="flex items-center gap-2">
      <BrandMark size={markSize} />
      <span className={`heading ${textClass}`}>Delco Chefs</span>
    </div>
  );
}
